import React from "react";
import Image from "next/image";

interface NextImageProps {
  src: string;
  alt: string;
  width?: number | `${number}`;
  height?: number | `${number}`;
  size?: string;
  style?: React.CSSProperties;
  className?: string;
  quality?: number | `${number}`;
  title?: string;
  priority?: boolean;
  loading?: "eager" | "lazy";
  unoptimized?: boolean;
  fetchPriority?: "high" | "low" | "auto";
  decoding?: "async" | "auto" | "sync";
}

export const NextImage = ({
  src,
  width,
  height,
  alt,
  size,
  style,
  className,
  title,
  quality,
  priority,
  loading,
  unoptimized,
  fetchPriority,
  decoding,
}: NextImageProps) => {
  const isSvg = typeof src === "string" && src.toLowerCase().endsWith(".svg");
  const finalLoading = priority ? undefined : loading || "lazy";

  return (
    <Image
      className={className}
      src={src}
      width={width}
      height={height}
      alt={alt}
      sizes={size || undefined}
      style={style}
      quality={quality}
      title={title}
      priority={priority}
      loading={finalLoading}
      fetchPriority={fetchPriority || (priority ? "high" : "auto")}
      decoding={decoding || (priority ? "sync" : "async")}
      unoptimized={unoptimized || isSvg}
    />
  );
};
